import { format, isValid, startOfDay } from "date-fns";

/**
 * Parses filter/API date strings into a local calendar Date.
 * Accepts `yyyy-MM-dd`, unpadded `yyyy-M-d`, and ISO datetimes (`...T...`).
 */
export const getDateFromFilter = (
  filterValue?: string | null
): Date | null => {
  if (!filterValue) {
    return null;
  }

  const datePart = filterValue.trim().split(/[T\s]/)[0];
  const [yearStr, monthStr, dayStr] = datePart.split("-");
  const year = Number(yearStr);
  const month = Number(monthStr);
  const day = Number(dayStr);

  if (
    !Number.isFinite(year) ||
    !Number.isFinite(month) ||
    !Number.isFinite(day) ||
    month < 1 ||
    month > 12 ||
    day < 1 ||
    day > 31
  ) {
    return null;
  }

  const dateFromString = new Date(year, month - 1, day);
  return isValid(dateFromString) ? dateFromString : null;
};

export const getDateStringFromDate = (date: Date) => {
  if (!isValid(date)) {
    return "";
  }

  return format(date, "yyyy-MM-dd");
};

/**
 * Calendar bounds for Mapa de Chuva advanced filters.
 * Uses the safra pluviometric window when valid, and always allows up to today
 * so the picker stays aligned with quick filters (Hoje/Ontem/etc.).
 */
export const getMapaDeChuvaPickerBounds = (
  periodoInicio?: string | null,
  periodoFim?: string | null
): { minDate?: Date; maxDate?: Date } => {
  const safraStart = getDateFromFilter(periodoInicio);
  const safraEnd = getDateFromFilter(periodoFim);
  const today = startOfDay(new Date());

  const maxDate =
    safraEnd && safraEnd.getTime() > today.getTime() ? safraEnd : today;

  const minDate =
    safraStart && safraStart.getTime() <= maxDate.getTime()
      ? safraStart
      : undefined;

  return { minDate, maxDate };
};
